import { useState } from 'react';

export default function CurriculumEditorPanel({
  section,
  sectionNumber,
  onUpdateTitle,
  onUpdateTopic,
  onDeleteTopic,
  onAddTopic,
}) {
  const [draftTopic, setDraftTopic] = useState('');

  if (!section) {
    return (
      <div className="cb-editor cb-editor--empty">
        <p>Select a section</p>
        <span>Choose a section from the list on the left, or add a new section to edit topics here.</span>
      </div>
    );
  }

  const handleAddTopic = () => {
    const t = draftTopic.trim();
    if (!t) return;
    onAddTopic(t);
    setDraftTopic('');
  };

  return (
    <div className="cb-editor">
      <div className="cb-editor__head">
        <p className="cb-editor__kicker">Editing section</p>
        <div className="cb-editor__title-row">
          <span className="cb-num-badge cb-num-badge--lg">{sectionNumber}</span>
          <input
            type="text"
            value={section.title}
            onChange={(e) => onUpdateTitle(e.target.value)}
            className="cb-input"
            placeholder="Section title"
            aria-label="Section title"
          />
        </div>
      </div>

      <p className="cb-editor__topics-label">Topics</p>

      <ul className="cb-topic-list">
        {section.topics.length === 0 ? (
          <li className="cb-topic-empty-hint">
            <p>No topics yet</p>
            <span>Add topics below — press Enter to add quickly.</span>
          </li>
        ) : (
          section.topics.map((topic, i) => (
            <li key={`${section.id}-t-${i}`}>
              <span className="cb-topic-bullet" aria-hidden>
                •
              </span>
              <input
                type="text"
                value={topic}
                onChange={(e) => onUpdateTopic(i, e.target.value)}
                className="cb-input cb-input--topic"
                placeholder="Topic"
                aria-label={`Topic ${i + 1}`}
              />
              <button
                type="button"
                onClick={() => onDeleteTopic(i)}
                className="cb-icon-btn"
                title="Remove topic"
                aria-label="Remove topic"
              >
                <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </li>
          ))
        )}
      </ul>

      <div className="cb-editor__footer">
        <label className="sr-only" htmlFor="cb-new-topic-input">
          Add topic
        </label>
        <div className="cb-topic-add-row">
          <input
            id="cb-new-topic-input"
            type="text"
            value={draftTopic}
            onChange={(e) => setDraftTopic(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddTopic();
              }
            }}
            placeholder="New topic — press Enter"
            className="cb-input"
          />
          <button type="button" onClick={handleAddTopic} className="cb-btn-solid-blue">
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
